module.exports = {
    smartBanner: {
        enableSmartBanner: false,
        daysHiddenAfterClose: 15,
        daysHiddenAfterView: 90,
        title: 'Woolworths',
        author: 'Woolworths',
        appleStore: 'On the App Store',
        googleStore: 'In Google Play',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/smart-banner.js